import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { scrollToId } from "@/lib/scroll";
import { FadeUp, SectionTag } from "@/components/motion";
import { CollectionCard } from "@/components/CollectionCard";

const FILTERS = [
  { id: "all", label: "All" },
  { id: "bracelets", label: "Bracelets" },
  { id: "necklaces", label: "Necklaces" },
  { id: "anklets", label: "Anklets" },
  { id: "charms", label: "Charms & Connectors" },
];

const ITEMS = [
  {
    id: "signature-cable",
    name: "Luxury Enamel Covered Chains Add Some Fun!",
    cat: "bracelets",
    metal: "Enamel",
    note: "Our most-loved everyday chain",
    img: "/images/enamel-chains.jpg",
  },
  {
    id: "barefoot-rolo",
    name: "Anklets and necklaces",
    cat: "anklets",
    metal: "14k Gold Filled",
    note: "Made for sun and salt air",
    img: "/images/anklet-necklace.jpg",
  },
  {
    id: "sculpted-paperclip",
    name: "Sterling Silver and Quality Gold filled chains to select from",
    cat: "bracelets",
    metal: "Bracelets",
    note: "Bold links, feather-light",
    img: "/images/chains-display.jpg",
  },
  {
    id: "charm-bar",
    name: "Completely Charming...Totally You",
    cat: "charms",
    metal: "Mixed Metals",
    note: "Unique, fun and personal charms",
    img: "/images/charms-ready-set-spark.jpg",
  },
];

export default function Collection({ onSelectService }) {
  const [filter, setFilter] = useState("all");
  const visible = ITEMS.filter((i) => filter === "all" || i.cat === filter);

  const select = (item) => {
    onSelectService(item.cat === "anklets" ? "anklets" : item.cat === "bracelets" ? "bracelets" : "both");
    scrollToId("booking");
  };

  return (
    <section id="collection" data-testid="collection-section" className="py-20 sm:py-28 lg:py-36">
      <div className="px-4 sm:px-8 lg:px-16 max-w-7xl mx-auto">
        <FadeUp className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-6 mb-12">
          <div>
            <SectionTag>The Collection</SectionTag>
            <h2 className="mt-3 font-serif tracking-tight text-ink text-3xl sm:text-4xl lg:text-5xl leading-tight">
              Chains that <span className="italic text-gold">last.</span>
            </h2>
          </div>
          <div className="flex flex-wrap gap-2" data-testid="collection-filters">
            {FILTERS.map((f) => (
              <button
                key={f.id}
                data-testid={`collection-filter-${f.id}`}
                onClick={() => setFilter(f.id)}
                className={`rounded-full px-5 py-2 text-xs font-medium tracking-wide transition-colors duration-300 ${
                  filter === f.id
                    ? "bg-ink text-alabaster"
                    : "border border-ink/15 text-stone-500 hover:border-gold hover:text-gold"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </FadeUp>

        <motion.div layout className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <AnimatePresence mode="popLayout">
            {visible.map((item, i) => (
              <CollectionCard key={item.id} item={item} index={i} onSelect={select} />
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </section>
  );
}
